import { addTimestamp, archives, publicArchives } from '@saucelabs/sl-util-axios';

type JobStatus = 'passed' | 'failed' | 'error' | 'complete' | 'in progress' | 'queued';

type RunMode = 'automatic' | 'manual' | 'scheduled' | 'ondemand';

type Cloud = 'vdc' | 'rdc';

interface ArchivesJobsParams {
  startDate?: number,
  endDate?: number,
  page?: number,
  size?: number,
  status: JobStatus[],
  buildName?: string[],
  device?: string[],
  os?: string[],
  ownerID?: string[],
  teamID?: string[],
  runMode?: RunMode[],
  cloud: Cloud,
  isOpenSauceUser: boolean,
  username: string,
}

export function getArchivedJobs(params: ArchivesJobsParams): Promise<any> {
  /* eslint-disable camelcase */
  const {
    isOpenSauceUser,
    username,
    cloud,
    buildName: build_name,
    startDate: start_date,
    endDate: end_date,
    ownerID: owner_id,
    teamID: team_id,
    runMode: run_mode,
    ...rest
  } = params;
  /* eslint-enable camelcase */

  if (isOpenSauceUser) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return publicArchives.get(
      '/jobs',
      addTimestamp({
        params: {
          username,
          ...rest,
        },
      }),
    );
  }

  return archives.get(
    `/${cloud}/jobs`,
    addTimestamp({
      params: {
        build_name,
        start_date,
        end_date,
        owner_id,
        team_id,
        run_mode,
        ...rest,
      },
    }),
  );
}
